<ng-container *transloco="let t">
  <div class="form-group">
    <div [ngClass]="{cssClass: cssClass !== undefined}">
      <label for="{{formControlName}}">{{ t(label!) }}
        @if (control.errors?.['required']) {
          <span>*</span>
        }</label>
      <textarea id="{{formControlName}}" class="form-control" [formControl]="control"
                name="{{formControlName}}" [placeholder]="placeholder ? t(placeholder) : t(label!)"
                rows="{{rows}}"></textarea>
      @if (control.touched) {
        @for( errorMessage of control.errors | errorMessages:formControlName; track errorMessage){
          <div class="errorMes pt-1">
          {{ errorMessage }}
        </div>
        }
      }
    </div>
  </div>
</ng-container>
